import discountTypes from "@/helpers/discountTypes";
import systems from "@/helpers/systems";

const defaultCustomerFormValue = ''

export default {
    customer: state => param => {
        let customer = state.configurator.customer
        if (customer.hasOwnProperty(param)) {
            return customer[param]
        } else {
            return defaultCustomerFormValue
        }
    },
    items: state => type => {
        return state.items.filter(item => item.type === type)
    },
    configuratorPayload: state => {
        let items = state.configurator.offer.items.map(item => {
            return {
                item_id: item.item_id,
                discount: item.discount,
                discount_type: discountTypes.indexOf(item.discountType),
                price: item.price,
                product: item.product,
                tax: item.tax,
                total: item.total,
                unit: item.unit.id,
                amount: item.amount,
                needed: item.needed || item.amount
            }
        })
        return {
            id: state.configurator.id,
            terraces: state.configurator.surfaces.map(surface => surface.id),
            customer: state.configurator.customer,
            partner: state.configurator.partner,
            order: {items},
            currency_id: state.configurator.currency.id ? state.configurator.currency.id : state.configurator.defaultCurrency.id,
            rate: state.configurator.rate,
            type: state.system
        }
    },
    manualOrderPayload: state => {
        let items = state.configurator.offer.items.map(item => {
            return {
                item_id: item.item_id,
                discount: item.discount,
                discount_type: discountTypes.indexOf(item.discountType),
                price: item.price,
                product: item.product,
                tax: item.tax,
                total: item.total,
                unit: item.unit.id,
                amount: item.amount,
                needed: item.needed || item.amount
            }
        })
        return {
            id: state.configurator.id,
            customer: state.configurator.customer,
            partner: state.configurator.partner,
            order: {items},
            currency_id: state.configurator.currency.id ? state.configurator.currency.id : state.configurator.defaultCurrency.id,
            rate: state.configurator.rate
        }
    },
    surface: state => index => state.configurator.surfaces[index],
    summaryOfferItemsTotal: state => {
        return state.configurator.offer.items.reduce((r, item) => r + item.total, 0)
    },
    summaryOfferItemsPrice: state => {
        return state.configurator.offer.items.reduce((r, item) => r + (item.price * item.amount), 0)
    },
    summarySurfaceArea: state =>{
        return state.configurator.surfaces.reduce((sum, surface) => sum + surface.area, 0);
    },
    partners: state => {
        return state.users.filter(user => user.role == 'Partner' && user.status != 0)
    },
    traders: state => {
        return state.users.filter(user => user.role == 'Handlowiec' && user.status != 0)
    },
    currencies: state =>{
        return state.currencies;
    },
    offerCurrency: state => {
        return Object.keys(state.configurator.currency).length == 0 ? state.configurator.defaultCurrency : state.configurator.currency;
    },
    offerRate: state => {
        return state.configurator.rate ?? state.configurator.defaultCurrency.rate;
    },
    elevationPlanks: state => {
        return state.manualMaterials.planks.filter(plank => plank.system.code == systems.elevation);
    },
    terracePlanks: state => {
        return state.manualMaterials.planks.filter(plank => plank.system.code == systems.terrace);
    },
    stairPlanks: state => {
        return state.manualMaterials.stair;
    },
    terraceSlats: state => {
        return state.manualMaterials.slats.filter(slat => slat.system.code == systems.terrace);
    },
    elevationSlats: state => {
        return state.manualMaterials.slats.filter(slat => slat.system.code == systems.elevation);
    },

}
